import { ActivityBookingTypesEnum } from '../generated/graphql';
import BookButton from './designsystem/BookButton';
import Stack from './Stack';
import { Flex } from '@rebass/grid';
import React, { FC, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';

interface Props {
    bookingType: ActivityBookingTypesEnum;
    selectedDayIsBookable: boolean;
    ticketText: ReactNode;
    externalBookingUrl?: string | null;
    onPlannerModalOpen: () => void;
    onBuyTickets: () => void;
}

const ActivityBookButton: FC<Props> = ({
    bookingType,
    externalBookingUrl,
    selectedDayIsBookable,
    ticketText,
    onPlannerModalOpen,
    onBuyTickets,
}) => (
    <Flex ml={[null, null, 'auto']} width={[1, null, 'auto']} alignItems="center">
        {bookingType === ActivityBookingTypesEnum.Direct && !selectedDayIsBookable && !ticketText && (
            <>
                <BookButton style={{ marginLeft: 'auto' }} onClick={onPlannerModalOpen}>
                    <FormattedMessage defaultMessage="Bekijk tijden" />
                </BookButton>
            </>
        )}

        {bookingType === ActivityBookingTypesEnum.External && (
            <BookButton onClick={onPlannerModalOpen} target="_blank">
                <FormattedMessage defaultMessage="Bekijk tijden" />
            </BookButton>
        )}
        {bookingType === ActivityBookingTypesEnum.Direct &&
            (selectedDayIsBookable || ticketText) &&
            !externalBookingUrl && (
                <Stack width={1} alignItems="center" variant="inline" spacing={3} justifyContent={['space-between']}>
                    <>
                        {ticketText && <Body variant="small">{ticketText}</Body>}
                        <BookButton onClick={ticketText ? onBuyTickets : onPlannerModalOpen}>
                            <FormattedMessage defaultMessage="Bekijk tijden" />
                        </BookButton>
                    </>
                </Stack>
            )}
    </Flex>
);
export default ActivityBookButton;
